<template>
  <div>
    <Status class="mb-7" />
    <FeedbackActions />
  </div>
</template>

<script>
import Status from "./Status.vue";
import FeedbackActions from "./FeedbackActions.vue";
export default {
  components: {
    Status,
    FeedbackActions,
  },
};
</script>

<style lang="scss" scoped></style>
